import { render, staticRenderFns } from "./ShippingManifestCreateForm.vue?vue&type=template&id=ce90764e&scoped=true&"
import script from "./ShippingManifestCreateForm.vue?vue&type=script&lang=ts&"
export * from "./ShippingManifestCreateForm.vue?vue&type=script&lang=ts&"
import style0 from "./ShippingManifestCreateForm.vue?vue&type=style&index=0&id=ce90764e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce90764e",
  null
  
)

export default component.exports